<template>
  <tr class="order-item-row" :class="{adding: !item || isEditing}">
    <td>
      <v-select v-if="isEditing" v-model="cost_category_id" :options="allCostCategories" class="form-control" :reduce="item => item.id"
                label="name" :searchable="true" :clearable="false" :placeholder="'- Select'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.category.name:'' }}</span>
    </td>
    <td>
      <v-select v-if="isEditing" v-model="cost_matrix_id" :options="filteredCostRecords" class="form-control" :reduce="item => item.id"
                label="description" :searchable="true" :placeholder="'- Cost item'"></v-select>
      <span v-else>{{ item && item.cost?item.cost.description:'' }}</span>
    </td>
    <td>
      <textarea v-if="isEditing" id="details" type="text" class="form-control" rows="2" placeholder="Details" v-model="details"></textarea>
      <span v-else>{{ item && item.details }}</span>
    </td>
    <td>
      <input v-if="isEditing" type="text" name="quantity" id="quantity" class="form-control" v-model="quantity">
      <span v-else>{{ item && item.quantity }}</span>
    </td>
    <td><span>{{ orderMakeup | moneyFormat }}</span></td>
    <td>
      <input v-if="isEditing" type="text" name="cost_rate" id="cost_rate" class="form-control" v-model="cost_rate">
      <span v-else>{{ item && item.cost_rate | moneyFormat }}</span>
    </td>
    <td><span>{{ costAmount | moneyFormat }}</span></td>
    <td>
      <input v-if="isEditing" type="text" name="sell_rate" id="sell_rate" class="form-control" v-model="sell_rate">
      <span v-else>${{ item?item.sell_rate:null | numberFormat }}</span>
    </td>
    <td><span>{{ orderAmount | moneyFormat }}</span></td>
    <td align="right">
      <beat-loader v-if="state == 'saving'"></beat-loader>
      <template v-else>
        <div v-if="isEditing">
          <a href="javascript:;" class="icon-checkmark" v-tooltip="'Save item'"
             @click="saveItem()"></a>&nbsp;
          <a href="javascript:;" class="icon-close" v-tooltip="'Cancel'"
             @click="cancelItem()"></a>
        </div>
        <div v-else>
          <a href="javascript:;" class="icon-pencil" v-tooltip="'Edit item'" @click="isEditing = true"></a>&nbsp;
          <a href="javascript:;" class="icon-trash" v-tooltip="'Remove item'" @click="confDelete"></a>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
  import { mapState } from 'vuex'
  import BeatLoader from 'vue-spinner/src/BeatLoader'
  import Service from '@/services/order'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return this.initialState();
    },
    props: ['item', 'idx'],
    computed: {
      ...mapState({
        allCostRecords: state => state.option.costs,
        allCostCategories: state => state.option.costCategories,
        orderItemTypes: state => state.option.orderItemTypes,
        order: state => state.order.order
      }),
      filteredCostRecords() {
        let self = this, records = [];
        for(let i in self.allCostRecords) {
          if(self.allCostRecords[i].category_id == self.cost_category_id) {
            records.push(self.allCostRecords[i]);
          }
        }
        return records;
      },
      orderMakeup() {
        if (this.sell_rate && this.cost_rate && this.quantity) {
          let amount = (this.sell_rate - this.cost_rate)*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      },
      costAmount() {
        if (this.cost_rate && this.quantity) {
          let amount = this.cost_rate*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      },
      orderAmount() {
        if (this.sell_rate && this.quantity) {
          let amount = this.sell_rate*this.quantity;
          if (amount)
            return amount;
        }
        return null;
      }
    },
    watch: {
      cost_matrix_id ( newVal ) {
        if ( newVal ) {
          let self = this, cost_item = window.getObjectByKeyValue(self.allCostRecords, 'id', newVal);
          if (cost_item) {
            if (!self.cost_rate)
              self.cost_rate = cost_item.cost;
            if (!self.sell_rate)
              self.sell_rate = cost_item.sell_tier1;
          }
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      initialState (){
        return {
          state: '',
          cost_category_id: 1,
          cost_matrix_id: '',
          quantity: '',
          details: '',
          cost_rate: '',
          sell_rate: '',
          isEditing: false
        }
      },
      loadItem () {
        let self = this;
        if ( !self.item ) {
          return;
        }
        if (self.item.cost)
          self.cost_category_id = self.item.cost.category_id;
        self.cost_matrix_id = self.item.cost_matrix_id;
        self.quantity = self.item.quantity;
        self.details = self.item.details;
        self.cost_rate = self.item.cost_rate;
        self.sell_rate = self.item.sell_rate;
      },
      init () {
        let self = this;
        Object.assign(this.$data, this.initialState());
        if ( !self.item ) {
          self.isEditing = true;
          return;
        }
        self.loadItem();
      },
      saveItem ( ) {
        let self = this;

        if ( self.state == 'saving' ) {
          return;
        }

        let postData = {};

        if ( !self.item || self.cost_matrix_id != self.item.cost_matrix_id )
          postData.cost_matrix_id = self.cost_matrix_id;

        if ( !self.item || self.quantity != self.item.quantity )
          postData.quantity = self.quantity;

        if ( !self.item || self.details != self.item.details )
          postData.details = self.details;

        if ( !self.item || self.cost_rate != self.item.cost_rate )
          postData.cost_rate = self.cost_rate;

        if ( !self.item || self.sell_rate != self.item.sell_rate )
          postData.sell_rate = self.sell_rate;

        if (!self.isValid())
          return false;

        self.state = 'saving';
        if(self.item) {
          Service.saveItem(self.order.id, self.item.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else{
              self.$notify({
                type: 'success',
                text: 'Order item updated successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              self.init();
            }
          }, () => {
            self.state = '';
          });
        }else{
          Service.createItem(self.order.id, postData, itemData => {
            self.state = '';
            if(typeof itemData.status != 'undefined' && itemData.status == 'FAILED'){
              self.$notify({
                type: 'error',
                text: itemData.error
              });
            }else {
              self.$notify({
                type: 'success',
                text: 'Order item created successfully'
              });
              self.$emit('item-saved', itemData, self.idx);
              self.init();
            }
          }, () => {
            self.state = '';
          });
        }
      },
      isValid() {
        let self = this, requiredFields = {
          'cost_matrix_id': 'Please select the cost item',
          'details': 'Please enter the details',
          'sell_rate': 'Please enter the order rate'
        };
        for(let f in requiredFields) {
          if (!self[f]) {
            self.$notify({
              type: 'error',
              text: requiredFields[f]
            });
            return false;
          }
        }
        return true;
      },
      cancelItem () {
        if (this.item) {
          this.loadItem(this.item);
          this.isEditing = false;
        } else {
          Object.assign(this.$data, this.initialState());
          this.$emit('item-cancelled');
        }
      },
      confDelete () {
        let self = this, item = self.item;
        self.$dialog
          .confirm('Are you sure you want to delete this item?', {
            html: true,
            loader: true,
            okText: "Yes, I'm sure",
            cancelText: "Cancel",
          })
          .then(dialog => {
            Service.deleteItem(item.order_id, item.id, (data) => {
              dialog.close();
              if(data.status == 'FAILED'){
                self.$notify({
                  type: 'error',
                  text: data.error
                });
              }else {
                self.$emit('item-deleted', self.idx);
              }
            });
          })
          .catch(() => {});
      }
    }
  }
</script>
